import React, { useMemo } from "react";
import PropTypes from "prop-types";

function LspLogo({ name = "" }) {
  const initials = useMemo(() => {
    const words = name.trim().split(" ");
    if (words.length === 1) {
      return name.substring(0, 2)?.toUpperCase?.();
    }
    return words.map((word) => word[0]?.toUpperCase?.())?.join?.("");
  }, [name]);

  return (
    <div className="general-info-form-logo-wrapper mb-4">
      <div
        className={
          initials.length > 3
            ? "general-info-form-logo-name"
            : "general-info-form-logo-name logoName"
        }
      >
        {initials}
      </div>
    </div>
  );
}

export default LspLogo;

LspLogo.propTypes = {
  name: PropTypes.string,
};
